import CIMSSelect from '../..'
import { usePayItemSelectContext } from './PayItemSelectContext'
import { PayItemSelectProps } from './types'

/**
 * a {@link CIMSSelect} component for Pay Item No Geometries
 *
 * allows you to mark it as simple, but complex is the default behavior
 *
 * you must wrap any components using this component in the PayItemSelectProvider
 */
const PayItemSelect: React.FC<PayItemSelectProps> = (props) => {
  const { showLabel, placeholder, ...rest } = props
  const { options, loading } = usePayItemSelectContext()
  return (
    <CIMSSelect
      placeholder={showLabel ? 'Pay Item' : placeholder}
      loading={loading}
      options={options}
      {...rest}
    />
  )
}

export default PayItemSelect
